import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="mx-auto max-w-md px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="mx-auto h-10 w-10 text-muted-foreground" />
      <h1 className="mt-4 text-2xl font-bold">Payment cancelled</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        No charge was made. Your cart is exactly as you left it.
      </p>
      <Link
        to="/cart"
        data-testid="payment-cancel-back-to-cart"
        className="mt-6 inline-block rounded-sm bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-secondary"
      >
        Back to cart
      </Link>
    </div>
  );
}
